// Polyfill rIC since some modern browser does not support them (ie Safari)
import './requestIdleCallback';

export default function polyfillEnvironment(): Promise<any[]> {
  const promises = [];
  // `intersection-observer` and `whatwg-fetch` will do the global patch
  // we just need to import it
  if (!window.IntersectionObserver) {
    promises.push(
      import(
        /* webpackChunkName: "intersection-observer-polyfill" */
        // @ts-expect-error ignore declaration since this is polyfill
        'intersection-observer'
      )
    );
  }

  if (!window.fetch) {
    /* webpackChunkName: "fetch-polyfill" */
    // @ts-expect-error ignore declaration since this is polyfill
    promises.push(import('whatwg-fetch'));
  }

  return Promise.all(promises);
}
